const cleanText = (value) => String(value ?? '').trim();

export function assertCompleteChecklistDescriptions(checklistResults, checklist) {
  const results = Array.isArray(checklistResults) ? checklistResults : [];
  const expected = Array.isArray(checklist) ? checklist : [];
  const isComplete = results.length === expected.length && expected.every((criterion, index) => {
    const result = results[index];
    return cleanText(result?.id) === cleanText(criterion?.id)
      && Boolean(cleanText(result?.description));
  });

  if (!isComplete) {
    throw new SyntaxError(
      'The AI scoring response must include a non-empty description for every checklist item.'
    );
  }

  return results;
}
